import axios from 'axios';

const isProd = process.env.NODE_ENV === 'production';
export const BASE_URL = isProd ? window.location.origin : 'http://localhost:8000';

const api = axios.create({
    baseURL: isProd ? '/api' : 'http://localhost:8000/api',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Clear local storage and trigger logout via custom event
            localStorage.removeItem('user');
            localStorage.removeItem('auth_token');
            window.dispatchEvent(new Event('unauthorized'));
        }
        return Promise.reject(error);
    }
);

export default api;
